<template>
  <div v-if="source" class="details-container">
    <div class="dialog-header">
      <p-button
        class="notifi-header-button"
        icon="pi pi-arrow-left"
        @click="handleSelectDetail(undefined)"
      />
      <h3 class="header-label">
        <label class="header-content">Alert Details</label>
      </h3>
      <p-button
        class="notifi-header-button"
        icon="pi pi-times"
        @click="handleClose"
      />
    </div>
    <div class="solid-line" />
    <div class="source-container">
      <h6 class="source-top-content-label">
        {{ formatTimestamp(props.source.createdDate) }}
      </h6>
      <div class="source-top-content-container">
        <h4 class="source-top-content">
          {{ content.topContent }}
        </h4>
      </div>
      <div class="source-bottom-content">
        {{ content.bottomContent }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { formatTimestamp } from '@/notifi-vue-package/utils/AlertHistoryUtils';
import { Types } from '@notifi-network/notifi-graphql';
import { computed } from 'vue';

const props = defineProps<{
  source: Types.NotificationHistoryEntryFragmentFragment;
  handleSelectDetail: (
    source?: Types.NotificationHistoryEntryFragmentFragment,
  ) => void;
  handleClose: () => void;
}>();

const content = computed<{
  topContent?: string;
  bottomContent?: string;
}>(() => {
  const detail = props.source?.detail;
  const typename = detail?.__typename;
  if (detail === undefined || typename === undefined) {
    return {};
  }

  switch (typename) {
    case 'GenericEventDetails': {
      return {
        topContent: detail.notificationTypeName,
        bottomContent: detail.genericMessage,
      };
    }
    case 'BroadcastMessageEventDetails': {
      return {
        topContent: detail.subject,
        bottomContent: detail.message,
      };
    }
  }

  return {};
});
</script>

<style scoped lang="scss">
.details-container {
  position: absolute;
  z-index: 30;
  flex: 1;
  background-color: #16162d;
  width: 100%;
  height: 100%;
  border-radius: 24px;
}

.dialog-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px 0px 24px;
}

.header-label {
  display: flex;
  align-items: center;
  text-align: center;
  margin-right: 6px;
}
.header-content {
  display: flex;
  text-align: start;
  justify-self: center;
  z-index: 20;
}

.solid-line {
  border-top: 1px solid #e5e4fa;
  opacity: 0.15;
}

.source-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 0px 24px 12px 24px;
  max-height: 420px;
}

.source-top-content-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.source-top-content-label {
  margin-bottom: 0;
  margin-top: 0;
  position: relative;
  top: 14px;
  display: flex;
  align-self: flex-end;
}

.source-top-content {
  margin-bottom: 10px;
}

.source-bottom-content {
  font-size: 15px;
  line-height: 24px;
}

$iconColor: #d4c4ed;
.notifi-header-button {
  background: none;
  border: none;
  width: auto !important;
  height: auto;
  color: transparentize($iconColor, 0.5) !important;

  &:hover,
  &:active,
  &:focus {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    color: transparentize($iconColor, 0.2) !important;
  }
}
</style>
